<template>
  <div>
    <template v-if="onProcess">
      <loader :content="'Please wait'" :visible="onProcess" />
    </template>
    <template v-else>
      <div class="container" style="padding-top: 75px;">
        <div class="row text-center">
          <template v-if="!paymentSuccess">
            <div class="image-failed"></div>
            <div class="col-md-8 col-md-offset-2 text-center">
              <h3>Oops! payment failed</h3>
              <p class="text-center mb-20">
                You can retry or change your payment method easily on the reservation page.
              </p>
              <div class="button-group">
                <router-link
                  :to="`/reservation/inquiry/${reservationId}`"
                  class="btn btn-primary"
                >
                  Go to reservation
                </router-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import paymentService from "@/services/shop/paymentService.js";

export default {
  data() {
    return {
      channel: null,
      reservationId: null,
      onProcess: true,
      countDown : 5, // second
      paymentSuccess: false
    }
  },
  async created() {
    this.channel = this.$route.query.channel;
    this.reservationId = this.$route.query.reservation_id;

    if (this.channel && this.reservationId) {

      if (this.channel === 'reddotpayment') {
        // await this.payUsingRdp();

        /*
          for now we use rdp push notify, so, do nothing, just redirect to reservation details .
          hold 5 second to wait rdp hit maverick
        */
        setTimeout(() => { this.redirectToRsvDetail(); }, 5000);
      }

      if (this.channel === 'paypal') {
        await this.payUsingPaypal();
      }

      if (this.channel === 'airwallex') {
        await this.payUsingAirwallex();
      }

      // setTimeout(() => {
      //     // alert('REDIRECT');
      //     this.onProcess = false;
      //     this.paymentSuccess = false;
      // }, 7000);
    } else {
      this.throwNotFound();
    }
  },
  methods: {
    redirectToRsvDetail() {
      this.$router.push({ path: `/reservation/inquiry/${this.reservationId}` });
    },
    throwNotFound() {
      this.$router.push({ path: '/404' });
    },
    async callPayCheckerApi(extraParams = '') {
      const queryParams = `?channel=${this.channel}${extraParams}`;

      try {
        this.onProcess = true;
        const response = await paymentService.payWithCredit(queryParams);

        if (response && response.isSuccess) {
          this.paymentSuccess = response.isSuccess;

          setTimeout(() => {
            this.onProcess = false;
            this.redirectToRsvDetail();
          }, 3000);
        } else {
          this.onProcess = false;
          if (response.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      } catch (error) {
        this.onProcess = false;
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async payUsingRdp() {
      const orderId = this.$route.query.order_id;
      const transactionId = this.$route.query.transaction_id;

      if (orderId && transactionId) {
        const extraParams = `&orderid=${orderId}&transactionid=${transactionId}`;
        await this.callPayCheckerApi(extraParams);
      } else {
        this.throwNotFound();
      }
    },
    async payUsingPaypal() {
      const token = this.$route.query.token;

      if (token) {
        const extraParams = `&token=${token}`;
        await this.callPayCheckerApi(extraParams);
      } else {
        this.throwNotFound();
      }
    },
    async payUsingAirwallex() {
      const paymentIntentId = this.$route.query.id;

      if (paymentIntentId) {
        const extraParams = `&orderId=${paymentIntentId}`;
        await this.callPayCheckerApi(extraParams);
      } else {
        const reservationPaymentId = this.$route.query.reservation_payment_id;

        if (reservationPaymentId) {
          const extraParams = `&reservationPaymentId=${reservationPaymentId}`;
          await this.callPayCheckerApi(extraParams);
        } else {
          this.throwNotFound();
        }
      }
    },
    countDownTimer(reservationId) {
      // if(this.countDown > 0) {
      //   setTimeout(() => {
      //       this.countDown -= 1;
      //       this.countDownTimer(reservationId);
      //   }, 1000);
      // }

      // if (this.countDown === 0) {
      //   this.$router.push({ path: `/reservation/inquiry/${reservationId}` });
      // }
    }
  },
};
</script>

<style scoped>
.underline-loader {
  color: #4FB848;
  font-weight: bold;
  font-size: 30px;
  padding:0 5px 15px 0;
  background:repeating-linear-gradient(90deg,currentColor 0 8%,#0000 0 10%) 200% 100%/200% 3px no-repeat;
  animation:c3 2s steps(6) infinite;
}
@keyframes c3 {to{background-position: 80% 100%}}
</style>



// WEBPACK FOOTER //
// src/components/payment/credit/redirect.vue